/**
 * Sticky PDP – Visibility + Add to Cart click proxy
 *
 * What it does:
 * - Watches the main PDP Add to Cart button visibility on scroll.
 * - When the main button is NOT visible in the viewport, it shows any sticky bar(s)
 *   by adding the class: `.is-visible` to each `.pdp-sticky`.
 * - When the main button IS visible, it hides sticky bar(s) by removing `.is-visible`.
 * - When the user clicks the sticky button, it simulates a click on the main PDP
 *   Add to Cart button (so it uses the theme's existing add-to-cart logic).
 *
 * Where it's used:
 * - Included in the Sticky PDP section/snippet on the PDP template(s) where the sticky exists.
 *
 * Dependencies / Notes:
 * - Requires sticky wrappers with class `.pdp-sticky` and a `data-product-id`
 * - Each sticky proxies the first add button in its own product's form:
 *   product-form[data-product-id="<id>"] button[type='submit'][name='add']
 * - Requires CSS to handle `.pdp-sticky` + `.is-visible` transitions/visibility.
 */

document.addEventListener("DOMContentLoaded", function () {
  const pairs = [];

  document.querySelectorAll(".pdp-sticky").forEach(function (sticky) {
    const productId = sticky.dataset.productId;
    if (!productId) return;

    const target = document.querySelector(
      "product-form[data-product-id='" + productId + "'] button[type='submit'][name='add']"
    );
    if (!target) return;

    pairs.push({ sticky: sticky, target: target });

    const cta = sticky.querySelector("button");
    if (cta) {
      cta.addEventListener("click", function () {
        target.click();
      });
    }
  });

  if (!pairs.length) return;

  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= window.innerHeight;
  }

  function toggleSticky() {
    pairs.forEach(function (pair) {
      pair.sticky.classList.toggle("is-visible", !isInViewport(pair.target));
    });
  }

  window.addEventListener("scroll", toggleSticky, { passive: true });
  toggleSticky();
});
